import React from 'react'
import PageBanner from '../Components/PageBanner'
import bannerBg from '../assets/img/Banners/MissionVisson.jpg';
import AboutThree from '../Components/About/AboutThree';
import CoreFeaturesOne from '../Components/Features/CoreFeaturesOne';
const VisonMison = () => {
  return (
    <>
       <PageBanner title='Mission & Vision  ' bannerBg={bannerBg} currentPage='Mission & Vision ' />
       <AboutThree/>
      
       <CoreFeaturesOne/>
    </ >
  )
}

export default VisonMison
